export const MAX_FILE_SIZE_IN_MEGABYTES = 10;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_IN_MEGABYTES * 1024 * 1024;

export const ACCEPTED_TYPES = {
  IMAGES: ['image/jpeg', 'image/png', 'image/webp'],
};

export const ITEMS_PER_PAGE = 50;